// extracted by mini-css-extract-plugin
module.exports = {"title":"auditTrail_title__7T5-4"};